import { change, initialize } from 'redux-form';
import { call, cancel, put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as action from '../../actions';
import * as actCapital from '../../actions/capital';
import {
  FAST_LOAN_SUBMISSION,
  FAST_LOAN_SUBMIT_FORM,
  INVESTMENT_PAGE_CHECK,
  MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST,
  MOKA_CAPITAL_SUBMIT_FORM_CAPITAL,
  PAGE_REQUEST_CAPITAL,
  PAGE_REQUEST_DASHBOARD,
  PAGE_REQUEST_RESULT,
  REQUEST_ALLOWED_PERMISSION,
  SEND_SIGNIN_CONTRACT_CLICK,
  SHOW_ERROR_NOTIFICATION,
  GET_KOINWORKS_SUPPORTED_LOCATIONS,
  MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM,
} from '../../actions/capital/constants';
import { CHECK_KOINWORKS_STATUS, LOGOUT } from '../../actions/constants';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';
import * as actNotification from '../../actions/notifications';

import * as apiCapital from '../../api/capital';
import {
  checkEligibility as checkEligibilityByOpenAPI,
  getConsent as getConsentByOpenAPI,
  getKoinworksSupportedLocations as getKoinworksSupportedLocationsByOpenAPI,
  submitFinalApprovalForm as submitFinalApprovalFormByOpenAPI,
} from '../../api/capital/openApi';
import * as apiProfile from '../../api/profile';
import {
  CAPITAL_DASHBOARD_PAGE,
  CAPITAL_FORM_APPLICATION_PAGE,
  CAPITAL_INCOMPLETE_PROFILE_ERROR,
  CAPITAL_INCOMPLETE_PROFILE_PAGE,
  CAPITAL_INTRO_PAGE,
  CAPITAL_LIST_LENDER,
} from '../../utils/capitalUtils';
import { assertErrorHasMessage } from '../../utils/assert';
import * as clevertapCapital from '../../clevertap/capital';
import { createKoinworksDto } from './Dto/koinworksDto';
import { createModalkuNewFormDto } from './Dto/modalkuDto';
import { createTaraliteDto } from './Dto/taraliteDto';
import { createKoinworksV2Dto } from './Dto/koinworksV2Dto';

function* fastLoanSubmissionCheck(args) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const { history } = args.payload;
    const resData = yield call(apiCapital.fastLoanSubmissionCheck);
    const { data } = resData.data;
    if (data.submissions.length > 0) {
      yield put(showPageLoadingSpinner(false));
      yield call(() => history.push('/capital/fast-loan/status'));
    } else {
      const resEligible = yield call(apiCapital.fastLoanEligibleCheck);
      const { lenders } = resEligible.data.data;
      yield put(showPageLoadingSpinner(false));
      let isAllRejected = true;
      lenders.forEach((lender) => {
        if (lender.status !== 'REJECTED') {
          isAllRejected = false;
          return true;
        }
      });

      if (isAllRejected) {
        yield call(() => history.push('/capital/fast-loan/conditions'));
      } else {
        yield put(actCapital.fastLoanAction.setTenorData(lenders[0].results));
        const provinces = yield call(apiCapital.getProvinces);
        const cities = yield call(apiCapital.getCities);
        yield put(actCapital.fastLoanAction.setProvinces(provinces.data.data));
        yield put(actCapital.fastLoanAction.setCities(cities.data.data));
      }
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

function* investmentPageCheck(args) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const { history } = args.payload;
    const resData = yield call(apiCapital.investmentSubmissionCheck);
    const { data } = resData.data;
    if (data.submissions.length > 0) {
      yield put(showPageLoadingSpinner(false));
      yield call(() => history.push('/capital/investment/status'));
    } else {
      const resEligible = yield call(apiCapital.investmentEligibleCheck);
      const { lenders } = resEligible.data.data;
      yield put(showPageLoadingSpinner(false));

      let isAllRejected = true;
      lenders.forEach((lender) => {
        if (lender.status !== 'REJECTED') {
          isAllRejected = false;
          return true;
        }
      });

      if (isAllRejected) {
        yield call(() => history.push('/capital/investment/conditions'));
      }
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

function* fastLoanSubmitFinalForm(args) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const resData = yield call(
      apiCapital.postFinalApprovals,
      args.payload.body
    );
    const { data } = resData;
    if (data) {
      yield put(actCapital.fastLoanAction.setSubmissionModal(true));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* showError() {
  yield put(
    actNotification.error(
      'There is some invalid form, please scroll up and check your form application'
    )
  );
}

export function* pageRequest(args) {
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const resProfile = yield call(apiProfile.getProfile);
    const resData = yield call(apiCapital.getPermissionStatus);
    const { data } = resData.data;

    const borrowerProfile = {
      userId: resProfile.data.business.user_id,
      userFirstName: resProfile.data.first_name,
      userLastName: resProfile.data.last_name,
      businessId: resProfile.data.business.id,
      businessName: resProfile.data.business.name,
      businessTypeId: resProfile.data.business.business_type_id,
      businessCategoryId: resProfile.data.business.business_category_id,
      businessEmail: resProfile.data.business.email
        ? resProfile.data.business.email
        : resProfile.data.email,
      allow: data.allow,
      firstLoan: data.first_loan,
      waitingLoanResult: data.waiting_result,
      businessAddress: resProfile.data.business.address,
      businessCity: resProfile.data.business.city,
      businessZipCode: resProfile.data.business.postal_code,
      businessProvince: resProfile.data.business.province,
    };

    yield put(actCapital.setBorrowerProfile(borrowerProfile));
    clevertapCapital.capitalMenuItem();

    if (data.allow) {
      if (args.payload) {
        const { history } = args.payload;
        const resEligible = yield call(apiCapital.termLoanEligibleCheck);
        const { lenders } = resEligible.data.data;

        let isAllRejected = true;
        lenders.forEach((lender) => {
          if (lender.status !== 'REJECTED' && lender.status !== 'FAILED') {
            isAllRejected = false;
            return true;
          }
        });

        if (isAllRejected) {
          yield call(() => history.push('/capital/term-loan/conditions'));
        } else {
          yield put(actCapital.pageRequestResult(borrowerProfile));
        }
      } else {
        yield put(actCapital.pageRequestDashboard(args.payload));
      }
    } else {
      yield put(actCapital.setCapitalPage(CAPITAL_INTRO_PAGE));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    if (error.message === CAPITAL_INCOMPLETE_PROFILE_ERROR) {
      yield put(actCapital.setCapitalPage(CAPITAL_INCOMPLETE_PROFILE_PAGE));
    } else {
      yield put(actNotification.error(error.message));
    }
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
    yield put(actCapital.changePageApplication(1));
  }
}

export function* cancelAction(args) {
  yield cancel(...args);
}

export function* allowPermission() {
  try {
    yield put(actCapital.sendingRequest(true));
    yield put(action.showProgressBar());
    yield call(apiCapital.allowPermission);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
    yield put(actCapital.pageRequest());
    yield put(actCapital.sendingRequest(false));
  }
}

export function* pageRequestDashboard(args) {
  try {
    yield put(actCapital.setCapitalPage(CAPITAL_DASHBOARD_PAGE));
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    yield put(actCapital.changeCapitalTab('product'));

    const resData = yield call(apiCapital.getDashboardList, args.payload);
    const { data } = resData.data;

    yield put(actCapital.setDashboardList(data.submissions));
    yield put(actCapital.setAllowToApply(data.apply_more));
    yield put(actCapital.changePageApplication(1));
    yield put(showPageLoadingSpinner(false));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
    yield put(actCapital.changePageApplication(1));
  }
}

export function* pageRequestResult(request) {
  const {
    borrowerProfile: {
      businessTypeId,
      businessCategoryId,
      businessEmail,
      waitingLoanResult,
      businessName,
      businessAddress,
      businessCity,
      businessZipCode,
      businessProvince,
      userFirstName,
      userLastName,
    },
  } = request.payload;
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    yield put(actCapital.setCapitalPage(CAPITAL_FORM_APPLICATION_PAGE));
    yield put(action.businessLocations());
    yield put(action.businessStarts());
    yield put(
      initialize('mokaCapital', {
        logo: '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        pre_approved_amount: '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        interest_rate: '',
        duration: '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        max_loan: '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        lender_name: '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        monthly_installment: '',
        email: businessEmail,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bank_statement_array: [{ code: '', name: '' }],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bank_statement_company_array: [{ code: '', name: '' }],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_name: !businessName ? '' : businessName,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        loans_type: 'PERSONAL',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        is_address_same_as_ktp: true,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_type: businessTypeId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_category: businessCategoryId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_address: businessAddress,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_city: businessCity,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_zipcode: businessZipCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_province: businessProvince,
        name: `${userFirstName} ${userLastName}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        first_name: userFirstName,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        last_name: userLastName,
      })
    );
    let isRejected = true;
    const approvalData: any[] = [];
    if (!waitingLoanResult) {
      const resData = yield call(apiCapital.postPreApprovals);
      const { data } = resData.data;
      yield put(actCapital.setLoanPeriod(data.tenures.sort((a, b) => a - b)));
      let index = 0;
      data.lenders.forEach((lender) => {
        const lenderTerms = lender.lender_disclaimer.split('\n');
        const lenderPromotionNotes = lender.lender_promotion.split('|');
        const lenderPromotionTnC = lenderPromotionNotes.slice(1);
        const lenderPromotionTitle = lenderPromotionNotes[0];
        const disclaimer = lenderTerms[5];
        const checklist1 = lenderTerms[1];
        const checklist2 = lenderTerms[3];
        const found = CAPITAL_LIST_LENDER.find(
          (lenderName) =>
            lenderName === lender.lender_name &&
            lender.status !== 'REJECTED' &&
            lender.province !== 'NOT ELIGIBLE'
        );
        if (found) {
          lender.results.forEach((result) => {
            const approval = {
              index,
              isOpen: false,
              isPromoOpen: false,
              lenderPromotionTnC,
              lenderPromotionTitle,
              logo: lender.lender_logo,
              name: lender.lender_name,
              disclaimer,
              checklist1,
              checklist2,
              maxLoan: result.pre_approved_amount,
              minLoan: result.minimum_loan,
              rate: result.interest_rate,
              tenor: result.duration,
              preApproveLoan: '',
              monthlyInstallment: 0,
              notValid: '',
            };
            approvalData.push(approval);
            index++;
            isRejected = false;
          });
        }
      });
    }
    if (isRejected) {
      yield put(actCapital.changePageApplication(4));
    } else {
      yield put(actCapital.setApprovals(approvalData));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* sendSignInContractClick(request) {
  try {
    const {
      payload: { documentId, previousList },
    } = request;
    const resData = yield call(apiCapital.signInContractClick, documentId);
    const { data } = resData.data;

    if (data.message === 'Success') {
      previousList.forEach((item) => {
        if (item.document.id === documentId) {
          item.document.viewed = true;
        }
      });
      yield put(actCapital.pageRequest());
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
  }
}

export function* onClickApplyLoan(request) {
  const {
    borrowerProfile: {
      businessTypeId,
      businessCategoryId,
      businessEmail,
      businessName,
      businessAddress,
      businessCity,
      businessZipCode,
      businessProvince,
      userFirstName,
      userLastName,
    },
    logo,
    maxLoan,
    name,
    rate,
    tenor,
    preApproveLoan,
    monthlyInstallment,
    resetForm,
    loansType,
  } = request.payload.loan;
  if (resetForm) {
    yield put(
      initialize('mokaCapital', {
        // this sis for reset form
        logo,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        pre_approved_amount: preApproveLoan.replace(/\./g, ''),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        interest_rate: rate,
        duration: tenor,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        max_loan: maxLoan,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        lender_name: name,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        monthly_installment: monthlyInstallment,
        email: businessEmail,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bank_statement_array: [{ code: '', name: '' }],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        bank_statement_company_array: [{ code: '', name: '' }],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_name: !businessName ? '' : businessName,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        loans_type: 'personal',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        is_address_same_as_ktp: true,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_type: businessTypeId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_category: businessCategoryId,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_address: businessAddress,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_city: businessCity,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_zipcode: businessZipCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        business_province: businessProvince,
        name: `${userFirstName} ${userLastName}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        first_name: userFirstName,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        last_name: userLastName,
      })
    );
  } else {
    yield put(change('mokaCapital', 'logo', logo));
    yield put(
      change(
        'mokaCapital',
        'pre_approved_amount',
        preApproveLoan.replace(/\./g, '')
      )
    );
    yield put(change('mokaCapital', 'interest_rate', rate));
    yield put(change('mokaCapital', 'duration', tenor));
    yield put(change('mokaCapital', 'max_loan', maxLoan));
    yield put(change('mokaCapital', 'lender_name', name));
    yield put(change('mokaCapital', 'monthly_installment', monthlyInstallment));
    yield put(change('mokaCapital', 'loans_type', loansType));
  }
  yield put(actCapital.changePageApplication(2));
}

export function* submitFormCapital(request) {
  let isSubmitSuccess = false;
  let requestData = {};
  const { form } = request.payload;
  const {
    businessType: businessTypeEnum,
    businessCategory: businessCategoryEnum,
  } = form;
  try {
    yield put(actCapital.sendingRequest(true));
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));

    // ==== Prepare RequestData =========
    if (form.lender_name.toLowerCase() === 'modalku') {
      requestData = {
        modalku: createModalkuNewFormDto(form, businessCategoryEnum),
      };
    } else if (form.lender_name.toLowerCase() === 'koinworks') {
      const bankStatements = form.bank_statement_array.map((bankStatement) => {
        if (
          Object.prototype.hasOwnProperty.call(bankStatement, 'bank_statement')
        ) {
          return bankStatement.bank_statement.code;
        }
        return '';
      });
      const bankStatementsCompany = form.bank_statement_company_array.map(
        (bankStatement) => {
          if (
            Object.prototype.hasOwnProperty.call(
              bankStatement,
              'bank_statement'
            )
          ) {
            return bankStatement.bank_statement.code;
          }
          return '';
        }
      );
      requestData = {
        koinworks: createKoinworksDto(
          form,
          bankStatements,
          bankStatementsCompany
        ),
      };
    } else if (form.lender_name.toLowerCase() === 'taralite') {
      requestData = {
        taralite: createTaraliteDto(
          form,
          businessTypeEnum,
          businessCategoryEnum
        ),
      };
    }
    // send approval to server
    yield call(apiCapital.postFinalApprovals, requestData);
    isSubmitSuccess = true;
    yield put(actCapital.changePageApplication(3));
  } catch (error) {
    assertErrorHasMessage(error);
    isSubmitSuccess = false;
    yield put(actNotification.error(error.message));
  } finally {
    clevertapCapital.submitFormCapitalByLenderNameAndSubmitStatus(
      {
        ...requestData[form.lender_name.toLowerCase()],
        maxLoan: form.maxLoan,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        lender_name: form.lender_name,
      },
      isSubmitSuccess
    );
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
    yield put(actCapital.sendingRequest(false));
  }
}

export function* getKoinworksSupportedLocations(data) {
  const { payload } = data;
  try {
    const response = yield call(
      getKoinworksSupportedLocationsByOpenAPI,
      payload.postalCode
    );
    const resData = response.data.data || [];
    yield put(
      actCapital.setKoinworksSupportedLocations(resData, payload.section)
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  }
}

export function* checkKoinWorksStatus(res) {
  const { payload } = res;
  try {
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    const resData = yield call(getConsentByOpenAPI);
    const { data } = resData.data;

    if (data.allow) {
      const resEligible = yield call(checkEligibilityByOpenAPI, 'KOINWORKS_V2');
      const { lenders } = resEligible.data.data;

      let isAllRejected = true;
      lenders.forEach((lender) => {
        if (lender.status !== 'REJECTED' && lender.status !== 'FAILED') {
          isAllRejected = false;
          return true;
        }
      });

      if (isAllRejected) {
        yield call(payload);
      } else {
        yield put(actCapital.setCapitalPage(CAPITAL_FORM_APPLICATION_PAGE));
      }
    } else {
      yield put(actCapital.setCapitalPage(CAPITAL_INTRO_PAGE));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    if (error.message === CAPITAL_INCOMPLETE_PROFILE_ERROR) {
      yield put(actCapital.setCapitalPage(CAPITAL_INCOMPLETE_PROFILE_PAGE));
    } else {
      yield put(actNotification.error(error.message));
    }
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
    yield put(actCapital.changePageApplication(1));
  }
}

export function* submitKoinWorksV2Form(data) {
  const { payload } = data;
  try {
    yield put(actCapital.sendingRequest(true));
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));

    const finalApprovalRequest = {
      koinWorksV2: createKoinworksV2Dto(payload),
    };
    yield call(submitFinalApprovalFormByOpenAPI, finalApprovalRequest);
    yield put(actCapital.changePageApplication(2));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotification.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
    yield put(actCapital.sendingRequest(false));
  }
}

export default function* capitalSaga() {
  const pageReqTask = yield takeLatest(PAGE_REQUEST_CAPITAL, pageRequest);
  const pageFastLoanCheck = yield takeLatest(
    FAST_LOAN_SUBMISSION,
    fastLoanSubmissionCheck
  );
  const pageInvestmentCheck = yield takeLatest(
    INVESTMENT_PAGE_CHECK,
    investmentPageCheck
  );
  yield takeLatest(PAGE_REQUEST_DASHBOARD, pageRequestDashboard);
  yield takeLatest(FAST_LOAN_SUBMIT_FORM, fastLoanSubmitFinalForm);
  yield takeLatest(PAGE_REQUEST_RESULT, pageRequestResult);
  yield takeLatest(REQUEST_ALLOWED_PERMISSION, allowPermission);
  yield takeLatest(SEND_SIGNIN_CONTRACT_CLICK, sendSignInContractClick);
  yield takeLatest(MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST, onClickApplyLoan);
  yield takeLatest(MOKA_CAPITAL_SUBMIT_FORM_CAPITAL, submitFormCapital);
  yield takeLatest(SHOW_ERROR_NOTIFICATION, showError);
  yield takeEvery(LOGOUT, cancelAction, [
    pageReqTask,
    pageFastLoanCheck,
    pageInvestmentCheck,
  ]);
  yield takeLatest(
    GET_KOINWORKS_SUPPORTED_LOCATIONS,
    getKoinworksSupportedLocations
  );
  yield takeLatest(CHECK_KOINWORKS_STATUS, checkKoinWorksStatus);
  yield takeLatest(MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM, submitKoinWorksV2Form);
}
